import { LOGIN_URI } from 'config';
import { isLoggedIn } from 'src/helpers/api/iam';
import { AppState } from 'src/redux/modules';
import { Dispatch } from 'redux';
import { post } from 'src/helpers/api/common';

export interface OpenContactOwnerAction {
  type: 'OPEN_CONTACT_OWNER';
}

export interface LoginContactOwnerAction {
  type: 'LOGIN_CONTACT_OWNER';
}

export function openContactOwner():
  | OpenContactOwnerAction
  | LoginContactOwnerAction {
  if (__CLIENT__ && !isLoggedIn()) {
    const returnUrl = encodeURIComponent(
      `${window.location.origin}${window.location.pathname}`
    );
    window.location.replace(`${LOGIN_URI}?returnUrl=${returnUrl}`);
    return { type: 'LOGIN_CONTACT_OWNER' };
  }

  return {
    type: 'OPEN_CONTACT_OWNER',
  };
}

export interface CloseContactOwnerAction {
  type: 'CLOSE_CONTACT_OWNER';
}

export function closeContactOwner(): CloseContactOwnerAction {
  return { type: 'CLOSE_CONTACT_OWNER' };
}

interface ContactOwnerData {
  id: string;
  message: string;
  subject: string;
  recaptcha: string;
}

export interface ContactOwnerRequestAction {
  type: 'CONTACT_OWNER_REQUEST';
}

export interface ContactOwnerSuccessAction {
  type: 'CONTACT_OWNER_SUCCESS';
}

export interface ContactOwnerFailureAction {
  type: 'CONTACT_OWNER_FAILURE';
}

export function contactOwner({
  id,
  message,
  subject,
  recaptcha,
}: ContactOwnerData) {
  return async (dispatch: Dispatch<AppState>) => {
    dispatch<ContactOwnerRequestAction>({ type: 'CONTACT_OWNER_REQUEST' });

    const payload = {
      projectId: id,
      subject,
      message,
      reCaptchaResponse: recaptcha,
    };

    try {
      const response = await post(`/projects/${id}/emails`, payload, {
        withCredentials: true,
      });

      if (!response.ok) {
        dispatch<ContactOwnerFailureAction>({ type: 'CONTACT_OWNER_FAILURE' });
      } else {
        dispatch<ContactOwnerSuccessAction>({ type: 'CONTACT_OWNER_SUCCESS' });
      }
    } catch (err) {
      dispatch<ContactOwnerFailureAction>({ type: 'CONTACT_OWNER_FAILURE' });

      throw err;
    }
  };
}

export interface SetRecaptchaAction {
  type: 'SET_RECAPTCHA';
  response: string;
}

export function setRecaptcha(response: string): SetRecaptchaAction {
  return { type: 'SET_RECAPTCHA', response };
}

export interface ClearRecaptchaAction {
  type: 'CLEAR_RECAPTCHA';
}

export function clearRecaptcha(): ClearRecaptchaAction {
  return { type: 'CLEAR_RECAPTCHA' };
}



// WEBPACK FOOTER //
// ./src/redux/modules/page/contactOwner.ts